import React from 'react';
import { LiveStreamingFilter } from '../../forms';
import {
  AccessControl,
  Button,
  DataTable,
  hasAccess,
  LiveStreamDelete,
  LiveStreamingBlocked,
  Modal,
  PERMISSION_KEYS,
  PERMISSION_TYPES,
  ToastBar,
} from '../../components';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';
import avatcoin from '../../assets/svg/avatcoin.svg';
import avatcoinsilver from '../../assets/images/silvercoin.png';
import { connect } from 'react-redux';
import { fetchLiveStreaming } from '../../actions';
import { dateFormatting, getDateAndTime } from '../../utils/dateMethods';
import { exportToCSV, exportToExcel } from '../../utils/exportToExcel';
import { LiveStreamingManagement } from '../../services';
import blockIcon from '../../assets/svg/block.svg';
import unblock from '../../assets/svg/unblock.svg';
import deleteIcon from '../../assets/svg/delete.svg';
import '../LayoutWrapperMain/LayoutWrapperMain.global.scss';

interface Props {
  fetchLiveStreamings: any;
  livestreaming: any;
}

const LiveStreaming = (props: Props) => {
  const {
    livestreaming,
    fetchLiveStreamings,
  } = props;
  const navigate = useNavigate();
  const { search } = useLocation();
  const { active } = queryString.parse(search);

  const [filter, setFilter] = React.useState<any>({
    startDate: '',
    endDate: '',
    domes: '',
    liveType: '',
    search: '',
    userType: active ? 'completed' : '',
    userId: active || '',
    page: 0,
    rowsPerPage: 10,
    isSortByTitle: '',
    isSortByCreated: '',
    isSortByScheduledDateTime: '',
    isSortByCategory: '',
    isAcceptedUserCount: '',
  });
  const [domes, setDomes] = React.useState<string[]>([]);
  const [selected, setSelected] = React.useState<string[]>([]);
  const [showModal, setShowModal] = React.useState(false);
  const [loaderExport, setLoaderExport] = React.useState(false);
  const [blocked, setBlocked] = React.useState<any>({
    show: false,
    id: null,
  });
  const [deleted, setDeleted] = React.useState<any>({
    show: false,
    id: null,
  });
  const [unblocked, setUnBlocked] = React.useState<any>({
    show: false,
    id: null,
  });
  const [edited, setEdited] = React.useState<any>({
    show: false,
    id: null,
  });
  const [selectedRows, setSelectedRows] = React.useState<any>([]);

  const [notification, setNotification] = React.useState({
    show: false,
    message: '',
  });

  const handleTimeDifference = (date1: any, date2: any) => {
    const diff = new Date(date2).getTime() > new Date(date1).getTime() ? new Date(date2).getTime() - new Date(date1).getTime() : new Date(date1).getTime() - new Date(date2).getTime();
    let msec = diff;
    const hh = Math.floor(msec / 1000 / 60 / 60);
    msec -= hh * 1000 * 60 * 60;
    const mm = Math.floor(msec / 1000 / 60);
    msec -= mm * 1000 * 60;
    const ss = Math.floor(msec / 1000);
    msec -= ss * 1000;
    return (`${hh}h:${mm}m:${ss}s`);
  };

  React.useEffect(() => {
    fetchLiveStreamings(filter);
  }, [fetchLiveStreamings, filter]);
  const handleSelectedClick = (event: React.MouseEvent<unknown>, name: any) => {
    const selectedIndex = selected.indexOf(name.id);
    let newSelected: string[] = [];
    let newSelectedRows: any = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name.id);
      newSelectedRows = newSelectedRows.concat(selectedRows, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
      newSelectedRows = newSelectedRows.concat(selectedRows.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
      newSelectedRows = newSelectedRows.concat(selectedRows.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
      newSelectedRows = newSelectedRows.concat(
        selectedRows.slice(0, selectedIndex),
        selectedRows.slice(selectedIndex + 1),
      );
    }
    setSelectedRows(newSelectedRows);
    setSelected(newSelected);
  };
  React.useEffect(() => {
    LiveStreamingManagement.getDomes().then((data) => {
      const domesData: any = [];
      if (data.data.data !== undefined) {
        data.data.data.forEach((ele: any) => {
          domesData.push({ key: ele._id, label: ele.name });
        });
      }
      setDomes(domesData);
    });
  }, []);
  const handleBlockUnblock = (modalValue: any, blockedid: string) => {
    setShowModal(true);
    switch (modalValue) {
      case 'blocked':
        setBlocked({ ...blocked, show: true, id: blockedid });
        break;
      case 'unblocked':
        setUnBlocked({ ...unblocked, show: true, id: blockedid });
        break;
      case 'delete':
        setDeleted({ ...deleted, show: true, id: blockedid });
        break;
      default:
        break;
    }
  };
  const actionButtons = (action: any, idS: any) => (
    <div className="actionBtnsWrapper">
      <AccessControl
        permissionKey={PERMISSION_KEYS.CATERGORIES}
        accessType={PERMISSION_TYPES.DELETE}
      >
        <div>
          {action !== 'completed' && action !== 'canceled' && <img
            src={deleteIcon}
            role="presentation"
            alt="delete"
            width="35"
            title="Delete"
            height="35"
            onClick={() => handleBlockUnblock('delete', idS)}
          />}
        </div>
      </AccessControl>
      <AccessControl
        permissionKey={PERMISSION_KEYS.CATERGORIES}
        accessType={PERMISSION_TYPES.EDIT}
      >
        <div>
          {action !== 'completed' && action !== 'canceled' && (action !== 'blocked' ? (
            <img
              src={blockIcon}
              role="presentation"
              alt="block"
              width="35"
              title="Block"
              height="35"
              onClick={() => handleBlockUnblock('blocked', idS)}
            />
          ) : (
            <img
              src={unblock}
              role="presentation"
              alt="unblock"
              width="35"
              title="Unblock"
              height="35"
              onClick={() => handleBlockUnblock('unblocked', idS)}
            />
          ))}
        </div>
      </AccessControl>
    </div>
  );
  const handleChangePage = (event: unknown, newPage: number) => {
    setFilter({ ...filter, page: newPage });
  };
  const count = livestreaming.data ? livestreaming.data['Pagination-Count'] : 0;
  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilter({ ...filter, page: 0, rowsPerPage: parseInt(event.target.value, 10) });
  };

  const hideActions = () => hasAccess(PERMISSION_KEYS.LIVE_STREAMING, PERMISSION_TYPES.ADD)
    || hasAccess(PERMISSION_KEYS.LIVE_STREAMING, PERMISSION_TYPES.EDIT)
    || hasAccess(PERMISSION_KEYS.LIVE_STREAMING, PERMISSION_TYPES.DELETE);

  const handleSubmitFilter = (data: any) => {
    if (data.domes !== ''
      || data.endDate !== null
      || data.liveType !== ''
      || data.search !== ''
      || data.startDate !== null
      || data.status !== '') {
      setFilter({
        ...filter,
        startDate: data.startDate,
        endDate: data.endDate,
        domes: data.domes,
        liveType: data.liveType,
        search: data.search.label,
        userType: data.status,
        page: 0,
      });
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    setBlocked(false);
    setDeleted({ ...deleted, show: false, id: null });
    setBlocked({ ...blocked, show: false, id: null });
    setEdited({ ...edited, show: false, id: null });
    setUnBlocked({ ...unblocked, show: false, id: null });
  };

  const headCells: any = [
    {
      id: 'sno', label: 'S.No', sort: false,
    },
    {
      id: 'eventtitle', label: 'Event Title', sort: true,
    },
    {
      id: 'description', label: 'Description', sort: false,
    },
    {
      id: 'username', label: 'Username', sort: false,
    },
    {
      id: 'avatar', label: 'Avatar', sort: false,
    },
    {
      id: 'livetype', label: 'Live Type', sort: false,
    },
    {
      id: 'dateofcreation', label: 'Date of Creation', sort: true,
    },
    {
      id: 'livedateandtime', label: 'Live Date & Time', sort: true,
    },
    {
      id: 'numberofparticipants', label: 'Number of Participants', sort: true,
    },
    {
      id: 'acceptance', label: 'Accepted User Count', sort: false,
    },
    {
      id: 'domes', label: 'Domes', sort: true,
    },
    {
      id: 'totalticketcount', label: 'Participant Limit',
    },
    {
      id: 'paymenttype', label: 'Payment Type',
    },
    {
      id: 'price', label: 'Price',
    },
    {
      id: 'discountprice', label: 'Discounted Price',
    },
    {
      id: 'status', label: 'Live Status',
    },
    {
      id: 'duration', label: 'Duration',
    },
    ...(hideActions() ? [{
      id: 'action', label: 'Action',
    }] : [])];
  const handleEventString = (evt: string) => {
    if (evt === 'private_event_paid') {
      return 'Private Event Paid';
    }
    if (evt === 'private_event_free') {
      return 'Private Event Free';
    }
    if (evt === 'public_event_free') {
      return 'Public Event Free';
    }
    if (evt === 'public_event_paid') {
      return 'Public Event Paid';
    }
    return '';
  };

  function createData(data: any, index: number): any {
    const idS = data._id;
    const Price = (
      <div className="c_price">
        <img src={avatcoin} alt="avatcoin" />
        <span>{data.goldPrice}</span>
      </div>
    );
    return {
      sno: filter.page * filter.rowsPerPage + index + 1,
      id: idS,
      eventtitle: data.title !== undefined ? (data.title.length > 20 ? (
        <div title={data.title}>
          {data.title.substring(0, 20)}
          ...
          {' '}
        </div>
      ) : data.title) : '',
      description: data.description !== undefined ? (data.description.length > 20 ? `${data.description.substring(0, 20)}...` : data.description) : '',
      username: data.user.username,
      avatar: <img src={data.imageUrl} alt="" />,
      livetype: handleEventString(data.eventType),
      dateofcreation: dateFormatting(data.createdAt),
      livedateandtime: getDateAndTime(data.startTime),
      numberofparticipants: data.joiningUserCount ? data.joiningUserCount : 0,
      acceptance: data.eventType.includes('private') ? data.acceptedUserCount : '--',
      domes: data.category ? data.category.name : '',
      totalticketcount: data.participationLimit, // data.eventType.includes('private') ? data.participationLimit : '--',
      paymenttype: data.isPaidEvent ? 'Paid' : 'Free',
      price: Price,
      discountprice: data.discountedPrice
        ? (
          <div className="c_price">
            <img src={avatcoin} alt="avatcoin" />
            <span>{data.discountedPrice.gold}</span>
            <span className="separator">+</span>
            <img src={avatcoinsilver} alt="avatcoin" />
            <span>{data.discountedPrice.silver}</span>
          </div>
        ) : '',
      status: (data.status === 'blocked' ? 'Blocked'
        : (data.status === 'live' ? 'Ongoing' : (data.status === 'completed'
          ? 'Ended' : data.status === 'canceled' ? 'Cancelled' : data.status[0].toUpperCase() + data.status.substring(1, data.status.length)))),
      duration: data.status === 'completed'
        ? (
          data.isAutoEnd
            ? handleTimeDifference(data.startTime, data.autoEndTime)
            : handleTimeDifference(data.startTime, data.eventCompletedDateTime)) : data.status === 'live' ? handleTimeDifference(data.startTime, new Date().toUTCString())
          : data.eventCompletedDateTime ? handleTimeDifference(data.startTime, data.eventCompletedDateTime) : '--',
      ...(hideActions() && {
        action: actionButtons(data.status, idS),
      }),
    };
  }

  const rows: any = [];
  if (livestreaming.data !== null && livestreaming.data) {
    livestreaming.data.data.forEach((ele: any, index: number) => {
      rows.push(createData(ele, index));
    });
  }

  const handleClick = (event: any, name: any) => {
    if (event.target.localName === 'input') {
      handleSelectedClick(event, name);
    } else if (event.target.localName !== 'img') {
      navigate(`/livestreaming/livestreaminfo/${name.id}`);
    }
  };

  const handleSort = (order: any, orderBy: any) => {
    if (orderBy === 'eventtitle') {
      setFilter({
        ...filter,
        page: 0,
        isSortByTitle: order === 'asc' ? '1' : '-1',
      });
    }
    if (orderBy === 'dateofcreation') {
      setFilter({
        ...filter,
        page: 0,
        isSortByCreated: order === 'asc' ? '1' : '-1',
      });
    }
    if (orderBy === 'livedateandtime') {
      setFilter({
        ...filter,
        page: 0,
        isSortByScheduledDateTime: order === 'asc' ? '1' : '-1',
      });
    }
    if (orderBy === 'domes') {
      setFilter({
        ...filter,
        page: 0,
        isSortByCategory: order === 'asc' ? '1' : '-1',
      });
    } // numberofparticipants
    if (orderBy === 'numberofparticipants') {
      setFilter({
        ...filter,
        page: 0,
        isAcceptedUserCount: order === 'asc' ? '1' : '-1',
      });
    }
  };

  const handleExport = (exportType: string) => {
    setLoaderExport(true);
    if (exportType === 'XLSX') {
      if (selectedRows.length > 0) {
        const selectedRowDataModified: any = [];
        selectedRows.forEach((ele: any) => {
          selectedRowDataModified.push({
            Sno: ele.sno,
            // id: ele.id,
            EventTitle: ele.eventtitle,
            Description: ele.description,
            Username: ele.username,
            Avatar: ele.avatar.props.src,
            LiveType: ele.livetype,
            DateOfCreation: ele.dateofcreation,
            LiveDateAndTime: ele.livedateandtime,
            NumberOfParticipants: ele.numberofparticipants,
            Accepted_User_Count: ele.acceptance,
            Dome: ele.domes,
            ParticipantLimit: ele.totalticketcount,
            PaymentType: ele.paymenttype,
            Price: `Gold(${ele.price.props.children[1].props.children})`,
            DiscountPrice: `Gold(${ele.discountprice.props.children[1].props.children}) + Silver(${ele.discountprice.props.children[4].props.children})`,
            Status: ele.status,
            Duration: ele.duration,
          });
        });
        exportToExcel(selectedRowDataModified, 'LiveStreamManagementData');
        setLoaderExport(false);
        setNotification({
          ...notification,
          show: true,
          message: 'Excel successfully downloaded.',
        });
      } else {
        LiveStreamingManagement.export({ ...filter, type: 'xlsx' }).then(() => {
          setLoaderExport(false);
          setNotification({
            ...notification,
            show: true,
            message: 'Excel has been sent on mail.',
          });
        }).catch((err: any) => {
          setLoaderExport(false);
          setNotification({
            show: true,
            message: err.response.data.message,
          });
        });
      }
    } else if (exportType === 'CSV') {
      if (selectedRows.length > 0) {
        const selectedRowDataModified: any = [];
        selectedRows.forEach((ele: any) => {
          selectedRowDataModified.push({
            Sno: ele.sno,
            // id: ele.id,
            EventTitle: ele.eventtitle,
            Description: ele.description,
            Username: ele.username,
            Avatar: ele.avatar.props.src,
            LiveType: ele.livetype,
            DateOfCreation: ele.dateofcreation,
            LiveDateAndTime: ele.livedateandtime,
            NumberOfParticipants: ele.numberofparticipants,
            Accepted_User_Count: ele.acceptance,
            Dome: ele.domes,
            ParticipantLimit: ele.totalticketcount,
            PaymentType: ele.paymenttype,
            Price: `Gold(${ele.price.props.children[1].props.children})`,
            DiscountPrice: `Gold(${ele.discountprice.props.children[1].props.children}) + Silver(${ele.discountprice.props.children[4].props.children})`,
            Status: ele.status,
            Duration: ele.duration,
          });
        });
        exportToCSV(selectedRowDataModified, 'LiveStreamManagementData');
        setLoaderExport(false);
        setNotification({
          ...notification,
          show: true,
          message: 'CSV successfully downloaded.',
        });
      } else {
        LiveStreamingManagement.export({ ...filter, type: 'xlsx' }).then(() => {
          setLoaderExport(false);
          setNotification({
            ...notification,
            show: true,
            message: 'Excel has been sent on mail.',
          });
        }).catch((err: any) => {
          setLoaderExport(false);
          setNotification({
            show: true,
            message: err.response.data.message,
          });
        });
      }
    }
  };

  const handleResetSorts = () => {
    setFilter({
      ...filter,
      startDate: '',
      endDate: '',
      status: '',
      search: '',
      domes: '',
      userType: '',
      liveType: '',
      isSortByTitle: '',
      isSortByCreated: '',
      isSortByScheduledDateTime: '',
      isSortByCategory: '',
      isAcceptedUserCount: '',
    });
  };
  return (
    <>
      {notification.show && (
        <ToastBar
          message={notification.message}
          handleCloseMethod={() => setNotification({
            ...notification,
            show: false,
            message: '',
          })}
        />
      )}
      {showModal && (
        <Modal
          id="block-user"
          isOpen={showModal}
          onClose={handleModalClose}
          onManageDisableScrolling={() => null}
          lightCloseButton={false}
        >
          {deleted.show && (
            <LiveStreamDelete
              handleModalClose={handleModalClose}
              id={deleted.id}
              fetchLiveStreaming={() => setFilter({ ...filter, page: 0 })}
            />
          )}
          {blocked.show && (
            <LiveStreamingBlocked
              handleModalClose={handleModalClose}
              id={blocked.id}
              fetchLiveStreaming={fetchLiveStreamings}
              status="blocked"
            />
          )}
          {unblocked.show && (
            <>
              <p>Event cancelled</p>
              <Button onClick={handleModalClose}>Ok</Button>
            </>
          )}
        </Modal>
      )}
      <LiveStreamingFilter
        handleFormSubmit={handleSubmitFilter}
        handleExport={handleExport}
        handleResetSorts={handleResetSorts}
        domes={domes}
        loaderExport={loaderExport}
      />
      <div className="dataTableCover">
        <DataTable
          headCells_={headCells}
          rows_={rows}
          rowClick={handleClick}
          selected={selected}
          setSelected={setSelected}
          setSelectedRows={setSelectedRows}
          page={filter.page}
          rowsPerPage={filter.rowsPerPage}
          loading={livestreaming.loadingInProgress}
          handleChangePage={handleChangePage}
          handleSort={handleSort}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          count={count}
        />
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  const { livestreaming } = state;
  return {
    livestreaming,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  fetchLiveStreamings: (payload: any) => dispatch(fetchLiveStreaming(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LiveStreaming);
